<script lang="ts">
  import UserProfile from '../../../components/admin/users/UserProfile.svelte';
  export let params: { uuid: string };
</script>

<UserProfile userUuid={params.uuid} />

